import React, { FC } from 'react';
import { SecurityWaitingTimes } from './SecurityWaitingTimes';
import { GenericPage } from '../../app/pages/ui/GenericPage';
import { useRemoteConfigValue } from '../../shared/remote-config/ui/useRemoteConfigValue';
import { ISecurityWaitingTimesPageData } from '../domain/models/ISecurityWaitingTimesPageData';

interface ISecurityWaitingTimesPageProps
	extends ISecurityWaitingTimesPageData {}

export const SecurityWaitingTimesPage: FC<ISecurityWaitingTimesPageProps> = ({
	page,
}) => {
	const { value: isEnabled } = useRemoteConfigValue(
		'security_wait_times_enabled',
	);

	return (
		<GenericPage page={page}>
			{isEnabled !== false && <SecurityWaitingTimes />}
		</GenericPage>
	);
};
